module.exports = __webpack_public_path__ + "media/images/global/icons/dress-82b745b93b2e13f2f95099791bd8583b.svg";